<template>
  <section class="sec-product">
    <div class="sec-titr">
      <h1 class="sec-titr__title">محصولات</h1>
    </div>
    <div class="product-dropdown-container">
      <div class="product-dropdown">
        <label class="product-dropdown-label" for="product-dropdown-select"
          >مرتب سازی بر اساس :
        </label>
        <select
          id="product-dropdown-select"
          class="product-dropdown-select"
          v-model="dropdownValue"
          @change="selectOption"
        >
          <option value="new">جدیدترین ها</option>
          <option value="cheap">قیمت از کم به زیاد</option>
          <option value="expensive">قیمت از زیاد به کم</option>
        </select>
      </div>
    </div>
    <main class="contaienr-product">
      <div class="container-product-list">
        <ul class="product-list">
          <li class="product-item" v-for="item in productList" :key="item">
            <card-part :carddata="item"> </card-part>
          </li>
        </ul>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dropdownValue: "new",
      productList: null,
    };
  },
  methods: {
    selectOption() {
      if (this.dropdownValue == "expensive") {
        this.productList.sort((a, b) => {
          return b.priceCalc - a.priceCalc;
        });
      } else if (this.dropdownValue == "cheap") {
        this.productList.sort((a, b) => {
          return a.priceCalc - b.priceCalc;
        });
      } else if (this.dropdownValue == "new") {
        this.productList.sort((a, b) => {
          return b.id - a.id;
        });
      }
    },
  },
  mounted() {
    this.productList=this.getProductHomeCard
    this.selectOption();
  },
  computed: {
    getProductHomeCard() {
      return this.$store.getters.getProductHomeCards;
    },
  },
};
</script>

<style></style>
